import clsx from 'clsx';

import { formatPriceWithEuro } from '../../utils/StringUtils';
import { calculateTotalToPay } from '../../utils/order/orderUtils';

export default function CartTotalSection({ cartItems, isJackpotMatchUsable }) {
  const hasPromo = cartItems.promoPrice !== cartItems.itemsPrice;

  const jackpotMatchAmount = isJackpotMatchUsable ? cartItems?.jackpot?.amount || 0 : 0;
  const totalToPay = calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, jackpotMatchAmount);

  return (
    <div className="mb-6">
      <div className={clsx("bg-gray-100 flex flex-col gap-4", {
        "pt-5": hasPromo || isJackpotMatchUsable,
      })}>
        {hasPromo || isJackpotMatchUsable ?
          <div className="flex justify-between items-center px-5 pt-2 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistRegular text-gray opacity-80">Total</div>
            <div className="text-[18px] geomanistBold text-black">
              {formatPriceWithEuro(cartItems.itemsPrice)}
            </div>
          </div> : null}

        {hasPromo ?
          <div className="flex justify-between items-center px-5 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[18px] geomanistRegular text-gray opacity-80">Promo</div>

            <div className="flex items-center gap-2">
              <span
                className="text-[16px] geomanistRegular font-semibold rounded-xl p-2"
                style={{
                  background: cartItems.midiDeal?.isActive
                    ? 'linear-gradient(to bottom right, #FFDE5980 0%, #FFDE5980 60%, #F19F1080 100%)'
                    : '#f5202099',
                }}
              > - {formatPriceWithEuro(cartItems.itemsPrice - cartItems.promoPrice)}</span>
            </div>
          </div> : null}

        {isJackpotMatchUsable ?
          <div className="flex justify-between items-center px-5 pb-4 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]">
            <div className="text-[16px] geomanistRegular text-gray opacity-80">Cagnotte</div>

            <div className="flex items-center gap-2">
              <span className="text-[16px] geomanistRegular font-semibold bg-[#DCBDF4] rounded-xl p-2"> - {formatPriceWithEuro(cartItems?.jackpot?.amount)}</span>
            </div>
          </div> : null}

        {cartItems?.jackpot?.isActive && !cartItems?.jackpot?.isAvailable ?
          <div className={clsx("flex justify-between items-center px-5 border-t-0 border-x-0 border-b border-solid border-[#e1e0e0]",
            {
              "pb-4": hasPromo,
              "py-4": !hasPromo
            }
          )}>
            <div className="text-[18px] geomanistRegular text-gray opacity-80">Cagnotte</div>

            <div className="flex items-center gap-2">
              <span className="text-[16px] geomanistRegular font-semibold bg-red-500 text-white rounded p-2">Indisponible</span>
            </div>
          </div> : null}
      </div>

      <div className={clsx("flex justify-between items-center py-7 px-5",
        "bg-white border border-solid border-gray-300 border-t-0 rounded-t-none rounded-bl-2xl rounded-br-2xl")}
        style={{ borderTop: '1px solid rgba(14, 11, 38, 0.1)' }}>
        <p className='text-[18px] geomanistRegular text-black'>Total à payer</p>

        <div className="flex items-center gap-7">
          {hasPromo || jackpotMatchAmount > 0 ?
            <div className="promotion_sliced text-[16px] geomanistRegular leading-8">
              {formatPriceWithEuro(cartItems.itemsPrice)}
            </div> : null}

          <p className="text-[18px] geomanistBold text-black">
            {formatPriceWithEuro(totalToPay)}
          </p>
        </div>
      </div>
    </div>
  )
}
